"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ManageBitwiseCheckboxes = void 0;
var _react = _interopRequireWildcard(require("react"));
var _core = require("@material-ui/core");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
  * Provides a wrapper to a bordered area with multiple checkboxes controlled by the binary bitwise value of a number
  *    
  * The value can be set directly by the parent (who must hold a reference to the component) by calling set().  Calling reset() changes the
  * value to the last value set by a call to set().  Calling accept() accepts the change and sets the initial value to the current.
  * 
  * 
  * When checkbox is changed, a callback is called with the new bitwise value.
  * 
  * The caller must supply props:
  * 
  * label:  the label for the area
  * labels: array of objects with two properties: {name, tooltip} which are strings containing the labels and tooltips for checkboxes. 
  *         Each array position corresponds to the bits in the value starting from the right.
  * json:   a key to identify the field, passed back to the callback. 
  * initialValue: the initial value for default checks in the checkboxes
  * 
  * The caller may supply the optional props:
  * 
  * editable: if the user has permissions to edit the field (otherwise read only), default true
  * onChange: the callback function called when the value changes state, called with two parameters: the json key prop, and the changed value
  * isReadOnly: set as read only. If not supplied, it is not read only unless otherwise restricted per above
  */
var ManageBitwiseCheckboxes = exports.ManageBitwiseCheckboxes = /*#__PURE__*/function (_Component) {
  function ManageBitwiseCheckboxes(props) {
    var _this;
    _classCallCheck(this, ManageBitwiseCheckboxes);
    _this = _callSuper(this, ManageBitwiseCheckboxes, [props]);
    _defineProperty(_this, "_json", void 0);
    _defineProperty(_this, "_initialValue", void 0);
    _defineProperty(_this, "_label", void 0);
    _defineProperty(_this, "_labels", void 0);
    _defineProperty(_this, "_changed", void 0);
    _defineProperty(_this, "_isEditable", void 0);
    _defineProperty(_this, "state", {
      currentValue: 0
    });
    _defineProperty(_this, "set", function (value) {
      _this._initialValue = value;
      _this.setState({
        currentValue: value
      });
    });
    _defineProperty(_this, "reset", function () {
      _this.setState({
        currentValue: _this._initialValue
      });
    });
    _this._label = props.label;
    _this._labels = props.labels;
    _this._json = props.json;
    _this._changed = props.onChange;
    _this._initialValue = props.initialValue;
    _this._isEditable = props.editable != null ? props.editable : true;
    _this.state.currentValue = props.initialValue;
    _this.checkboxChanged = _this.checkboxChanged.bind(_this);
    return _this;
  }
  _inherits(ManageBitwiseCheckboxes, _Component);
  return _createClass(ManageBitwiseCheckboxes, [{
    key: "accept",
    value: function accept() {
      this._initialValue = this.state.currentValue;
    }
  }, {
    key: "checkboxChanged",
    value: function checkboxChanged(bitPosition, oldBit) {
      var newValue = this.state.currentValue;
      if (oldBit === 0) newValue |= 1 << bitPosition; //bit was 0, flip to 1
      else newValue &= ~(1 << bitPosition); //bit was 1, flip to 0

      this.setState({
        currentValue: newValue
      });
      if (this._changed) this._changed(this._json, newValue);
    }
  }, {
    key: "getValue",
    value: function getValue() {
      return this.state.currentValue;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var disabled = this.props.isReadOnly || !this._isEditable || !this._json;
      var checkboxes = this._labels.map(function (label, index) {
        return {
          label: label.name,
          tooltip: label.tooltip,
          bitPosition: index,
          bitVal: _this2.state.currentValue & 1 << index
        };
      });
      return /*#__PURE__*/_react["default"].createElement("div", {
        style: this.props.style
      }, /*#__PURE__*/_react["default"].createElement(_core.Typography, {
        variant: "body2",
        style: {
          fontSize: 12,
          color: 'gray',
          marginLeft: 5
        }
      }, this._label), /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          border: '1px solid #CCCCCC',
          borderRadius: '4px',
          padding: 10
        }
      }, checkboxes.map(function (checkbox, index) {
        return /*#__PURE__*/_react["default"].createElement(_core.Tooltip, {
          key: index,
          title: checkbox.tooltip ? checkbox.tooltip : ""
        }, /*#__PURE__*/_react["default"].createElement(_core.FormControlLabel, {
          key: index,
          control: /*#__PURE__*/_react["default"].createElement(_core.Checkbox, {
            size: "medium",
            color: "primary",
            disabled: disabled,
            checked: checkbox.bitVal > 0,
            onChange: function onChange() {
              return _this2.checkboxChanged(checkbox.bitPosition, checkbox.bitVal);
            }
          }),
          labelPlacement: "end",
          label: /*#__PURE__*/_react["default"].createElement(_core.Typography, {
            variant: "body2",
            style: {
              fontSize: 12,
              marginTop: 2
            },
            color: "textSecondary"
          }, checkbox.label)
        }));
      })));
    }
  }]);
}(_react.Component);